import type { CardEngineScheduledCallRow } from "@tycho/web-bindings/types";
import { CompletedActionCard } from "@/web/routes/_protected/smb/-dashboard/-CompletedActionCard";
import type { SmbActionDefinition } from "@/web/routes/_protected/smb/-dashboard/-types";

export function createScheduleCallCompleted(props: {
  scheduledCall: CardEngineScheduledCallRow;
}): SmbActionDefinition {
  return {
    id: "schedule-call:done",
    category: "generic",
    canSkip: false,
    render: () => (
      <CompletedActionCard
        category="generic"
        badge="Checkpoint"
        title="Call scheduled"
        details={{
          title: "Call scheduled",
          children: (
            <>
              <p>
                Your call is scheduled for{" "}
                <span className="font-semibold">
                  {props.scheduledCall.startTimestamp
                    .toDate()
                    .toLocaleString("en-us", { month: "short", day: "numeric" })}
                </span>{" "}
                at{" "}
                <span className="font-semibold">
                  {props.scheduledCall.startTimestamp
                    .toDate()
                    .toLocaleTimeString("en-us", { hour: "numeric", minute: "2-digit" })}
                </span>
                .
              </p>
              {props.scheduledCall.location && <p>Location: {props.scheduledCall.location}</p>}
              {props.scheduledCall.joinUrl && (
                <p>
                  <a href={props.scheduledCall.joinUrl} target="_blank" rel="noopener noreferrer">
                    Join via Zoom
                  </a>
                </p>
              )}
            </>
          ),
        }}
      />
    ),
  };
}
